import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { NotificationsService } from 'angular2-notifications';
import { HttpParams } from '@angular/common/http';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { DatatableService } from '../../../shared/services/datatable.service';
import { RelacaoIndustriaService } from './relacao-industria.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DocumentoHelper } from '../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-relacao-industria',
  templateUrl: './relacao-industria.component.html',
  styleUrls: ['./relacao-industria.component.scss']
})
export class RelacaoIndustriaComponent implements OnInit {

  @ViewChild('myTable', { static: true })
  public myTable: DatatableComponent;

  public formRelacaoIndustria = null;
  public tableLimit = 20;
  public rowData = null;

  datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();
  public customLogin = null;
  /** Auxiliar de máscara CPF/CNPJ para o filtro cnpj. */
  public cnpjMaskAux = null;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private paginationService: SpringDatatablePaginationService,
    private datatableService: DatatableService,
    private service: RelacaoIndustriaService,
    private spinnerService: NgxSpinnerService,
    private notifications: NotificationsService,

  ) {

    this.rowData = [];

    this.paginationService.setDatatablePagination(this.datatablePagination);


  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.myTable);

    this.formRelacaoIndustria = this.formBuilder.group({
      cnpj: [null],
      nomeFantasia: [null],
    });

  }

  ngOnDestroy() {
    this.datatableService.unsubscribeTable(this.myTable);
  }

  buscarIndustria(data: any, page?: any) {

    let params = new HttpParams();

    const pageZeroBased =
      page != null && page !== undefined && page !== '' && !isNaN(Number(page))
        ? Number(page)
        : 0;
    params = params.append('page', String(pageZeroBased + 1));

    params = params.append('size', String(this.tableLimit));

    const cnpjNorm = this.normalizarCnpjCpfParaBackend(data.cnpj);
    if (cnpjNorm !== '') {
      params = params.append('cnpj', cnpjNorm);
    }
    if (data.nomeFantasia != null) {
      params = params.append('nomeFantasia', data.nomeFantasia);
    }

    this.spinnerService.show();

    this.service.industryRelationship(params, (response => {

      this.rowData = response.list;
      this.paginationService.setInfo(response);
      this.spinnerService.hide();

    }), error => {
      this.spinnerService.hide();
      this.limparForm();
      this.notifications.error(error.message);
    });

  }

  limparForm() {

    this.rowData = null;

  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  getCpfCnpjMask(): string {
    const ctrl = this.formRelacaoIndustria && this.formRelacaoIndustria.get('cnpj');
    const doForm = ctrl ? ctrl.value : null;
    const raw =
      this.cnpjMaskAux != null && String(this.cnpjMaskAux).trim() !== ''
        ? this.cnpjMaskAux
        : doForm;
    return DocumentoHelper.getMascaraCpfCnpj(raw);
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) {
      return '';
    }
    const str = String(value);
    if (str === '') {
      return '';
    }
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }

}
